export default __webpack_public_path__ + "static/media/united-kingdom.dfc1ce98.svg";